var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-content"},[_c('landing'),_c('rosa-graf'),_c('services'),_c('voucher'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }